export default {
    'UsedTime': '已用时{time}',
    'UsedTimeNew': '已用时：',
    'FlowTrack': '流程跟踪',
    'Participant': '当前处理人',
    'Participants': '当前处理人:',
    'FinishNode': '已办节点',
    'ProcessNode': '进行中节点',
    'WrongNode': '异常节点',
    'UnstartNode': '未开始',
    'Person': '{length}人',
    'chartTips': '流程图可手势调整大小',
    'trust': '【{name}委托】',
    approvalLog: {
        circulateNum: '传阅{num}人',
        circulatedNum: '已阅{num}人',
        uncirculateNum: '未阅{num}人',
        turnover: '人员调整',
        newOwner: '新拥有者',
        handlingSuggestion: '处理意见',
        operator: '操作人',
        newHandler: '调整后处理人',
        workflowAdjust: '流程调整',
        nodeAdjust: '节点调整',
        whoseAdjustParticipant: '{who}的加签',
        whoseTransfer: '{who}的转办'
    },
    WorkflowActions: {
        Nullify: '作废流程',
        Delete: '删除流程',
        ActivateNode: '激活其他节点',
        AdjustHandler: '调整当前处理人',
        FinishInstance: '结束流程',
        EditOwner: '修改拥有者',
        EditTemplate: '修改流程模板',
        CancelAllTask: '取消当前节点所有任务',
        SelectHandler: '选择当前处理人',
        CancelTips1: '取消当前节点的所有任务后，流程会停留在当前节点',
        SelectNode: '选择节点',
        pleaseSelect: "请选择",
        DELETE_WORKFLOW: '流程删除后该流程所有数据将删除，且删除后不可恢复，确定要删除？',
        COMPLETED_WORKFLOW: '是否提前结束流程？',
        ADJUST_PARTICIPANT: '是否调整当前处理人？',
        MODIFY_OWNER: '是否修改拥有者？',
        ACTIVATE_ACTIVITY: '是否激活${activityName}节点？',
        CANCELED_ACTIVITY_WORKITEM: '取消当前节点所有任务后流程会停滞，确定要取消？',
        CANCELED_WORKFLOW: '作废后该流程将停止流转，确定要作废？',
        ACTIVATE_ACTIVITY_EMPTY: '激活节点不能为空！',
        ADJUST_PARTICIPANT_EMPTY: '当前处理人不能为空！',
        MODIFY_OWNER_EMPTY: '拥有者不能为空！',
        MODIFY_OWNER_DEPARTMENT_EMPTY: '拥有者部门不能为空！',
    },
    approvalInfo: {
        action: "操作动作",
        owoner: "新拥有者",
        department: "拥有者部门",
        node: "选择节点",
        processor: "调整后处理人",
        opinion: "处理意见",
        operator: "操作人",
        time: "操作时间",
    },
    'WorkflowActionStatus': {
        'Submit': '提交',
        'Submits': '提交',
        'Cancel': '作废',
        'Agree': '同意',
        'DisAgree': '不同意',
        'AdjustParticipant': '加签',
        'ActivateActivity': '激活其他节点',
        'ADJUST_PARTICIPANT': '调整当前处理人',
        'CANCELED_ACTIVITY_WORKITEM': '取消节点所有任务',
        'MODIFY_OWNER': '修改拥有者',
        'Assist': '协办',
        'Forward': '转办',
        'Reject': '驳回',
        'FinishInstance': '结束流程',
        'UnRead': '待阅',
        'Read': '已阅',
        'Circularize': '传阅',
        'Empty': '',
        'Revoke': '撤回',
        'BeCanceled': '被取消',
        'AutoCanceled': '自动取消',
        'DECLINE': '拒绝'
    },
    'WorkItemStatus': {
        'NotStarted': '未启动',
        'Processing': '进行中',
        'Completed': '已完成',
        'Canceled': '被取消',
        'Draft': '草稿',
        'BeCanceled': '被取消',
    },
    'Operationworkflow': '流程运维',
};
